import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CertificationBadge = ({ certification }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center text-center">
      <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-full bg-muted flex items-center justify-center mb-3">
        <Image
          src={certification?.logo}
          alt={certification?.logoAlt}
          className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 object-contain"
        />
      </div>
      <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">
        {certification?.name}
      </h4>
      <p className="text-xs text-muted-foreground mb-2">{certification?.issuer}</p>
      <div className="flex items-center gap-1 text-xs text-success">
        <Icon name="CheckCircle2" size={14} />
        <span>Verified {certification?.year}</span>
      </div>
    </div>
  );
};

export default CertificationBadge;